import { render } from "./MovePage.vue?vue&type=template&id=1567412c&scoped=true"
import script from "./MovePage.vue?vue&type=script&lang=js"
export * from "./MovePage.vue?vue&type=script&lang=js"

import "./MovePage.vue?vue&type=style&index=0&id=1567412c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1567412c"]])

export default __exports__